<template>
  <div class="saved-phrases">
    <div class="saved-phrases__conf-popup" 
      ref="refConfList" 
      v-show="confidencesToShow"
      @click="hideConfidences()">
        <div class="saved-phrases__conf-list" @click="$event.stopPropagation()">
          <div class="saved-phrases__conf-list-header">
            <div class="saved-phrases__conf-header-title">
              {{$t('plugins.nlp.savedPhrases.confidences')}}
            </div>
            <fai icon="times" class="saved-phrases__conf-header-icon" @click="hideConfidences"/>
          </div>
          <div class="saved-phrases__conf-list-content">
            <div class="saved-phrases__conf-list-elem"
              v-for="(item, index) in confidencesToShow" :key="index">
              <div class="saved-phrases__conf-list-intent">
                {{item.intents_name}}
              </div>
              <div class="saved-phrases__conf-list-conf">
                {{formatConfidenceValue(item.confidence)}}
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="saved-phrases__top-label-popup" ref="refIntentLabel" v-show="labelToShow">
      {{labelToShow}}
    </div>
    <div class="saved-phrases__table">
      <div class="saved-phrases__text saved-phrases__text-header saved-phrases__header">
        {{$t('plugins.nlp.savedPhrases.table.header.phrase')}}
      </div>
      <div class="saved-phrases__top-conf saved-phrases__top-conf-header saved-phrases__header">
        {{$t('plugins.nlp.savedPhrases.table.header.top')}}
      </div>
      <div class="saved-phrases__top-conf saved-phrases__top-conf-header saved-phrases__header">
        {{$t('plugins.nlp.savedPhrases.table.header.details')}}
      </div>
      <div class="saved-phrases__top-conf saved-phrases__top-conf-header saved-phrases__header">
        {{$t('plugins.nlp.savedPhrases.table.header.assign')}}
      </div>
      <div class="saved-phrases__top-conf saved-phrases__top-conf-header saved-phrases__header">
        {{$t('plugins.nlp.savedPhrases.table.header.delete')}}
      </div>
      <div class="saved-phrases__content">
        <div class="saved-phrases__text saved-phrases__text-elem saved-phrases__elem"
          v-for="(item, index) in getActualPage()" :key="index+'text'">
          {{item.phrase}}
        </div>
        <div class="saved-phrases__top-conf saved-phrases__top-conf-elem"
          v-for="(item, index) in getActualPage()" :key="index+'conf'">
          <div class="saved-phrases__top-conf-item" :ref="'refConf'+index+''+index2"
            :style="{ 'background': getConfidenceColor(conf.confidence) }"
            v-for="(conf, index2) in getTopConfidences(item.confidences, 6)" :key="index2+'conf-item'"
            @mouseover="showIntentLabel($event, index, index2)"
            @mouseout="hideIntentLabel()">
            {{formatConfidenceValue(conf.confidence)}}
          </div>
          <div class="saved-phrases__no-data-text" v-if="item.confidences.length === 0">
            {{$t('plugins.nlp.savedPhrases.table.nodata')}}
          </div>
        </div>
        <div class="saved-phrases__info"
          v-for="(item, index) in getActualPage()" :key="index+'info'">
          <fai icon="question-circle" class="saved-phrases__info-icon" v-if="item.confidences.length !== 0"
            @click="showConfidences(index)"/>
          <div class="saved-phrases__no-data-text" v-else>
            {{$t('plugins.nlp.savedPhrases.table.nodata')}}
          </div>
        </div>
        <div class="saved-phrases__assign"
          v-for="(item, index) in getActualPage()" :key="index+'assing'">
          <sel
            @input="intentSelect($event, index)"
            class="saved-phrases__intent-select">
            <option :value="null">{{ $t('plugins.nlp.savedPhrases.noAssign') }}</option>
            <option
              v-for="intent in intents"
              :key="intent.id"
              :value="intent.id"
            >{{ intent.name }}</option>
          </sel>
        </div>
        <div class="saved-phrases__del"
          v-for="(item, index) in getActualPage()" :key="index">
          <fai icon="times" class="saved-phrases__del-icon" @click="delSaved(index)"/>
        </div>
      </div>
      <div class="saved-phrases__footer">
        <div class="saved-phrases__navi-actual">
          {{$t('plugins.nlp.savedPhrases.table.footer.showing')}} {{limit*page}}-{{pageItemsCount}} {{$t('plugins.nlp.savedPhrases.table.footer.of')}} {{phrases.length}}
        </div>
        <div class="saved-phrases__navi-action">
          <div class="saved-phrases__navi-buttons">
            <fai icon="fast-backward" class="saved-phrases__navi-buttons-icon" @click="backwardPage"
              :class="[page>0 ? '' : 'saved-phrases__navi-buttons-icon--inactive' ]"/>
            <fai icon="step-backward" class="saved-phrases__navi-buttons-icon" @click="prevPage"
              :class="[page>0 ? '' : 'saved-phrases__navi-buttons-icon--inactive' ]"/>
            <div class="saved-phrases__navi-text"> 
              {{$t('plugins.nlp.savedPhrases.table.footer.page')}} {{page+1}} {{$t('plugins.nlp.savedPhrases.table.footer.of')}} {{Math.floor(phrases.length/limit) + 1}}
            </div>
            <fai icon="step-forward" class="saved-phrases__navi-buttons-icon" @click="nextPage"
              :class="[page<Math.floor(this.phrases.length/this.limit) ? '' : 'saved-phrases__navi-buttons-icon--inactive' ]"/>
            <fai icon="fast-forward" class="saved-phrases__navi-buttons-icon" @click="forwardPage"
              :class="[page<Math.floor(this.phrases.length/this.limit) ? '' : 'saved-phrases__navi-buttons-icon--inactive' ]"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios"
export default {
  data () {
    return {
      phrases: [],
      labelToShow: null,
      confidencesToShow: null,
      page: 0,
      limit: 30
    }
  },

  props: {
    intents: Array,
    entities: Object
  },

  mounted () {
    this.fetchSavedPhrases()
  },

  computed: {
    pageItemsCount () {
      return this.page * this.limit + this.getActualPage().length 
    }
  },

  methods: {
    forwardPage () {
      this.page = Math.floor(this.phrases.length/this.limit)
    },

    backwardPage () {
      this.page = 0
    },

    nextPage () {
      if(this.page >= Math.floor(this.phrases.length/this.limit)) return
      this.page++
    },

    prevPage () {
      if(this.page <= 0) return
      this.page--
    },

    getActualPage () {
      return this.phrases.slice(this.page * this.limit, this.page * this.limit + this.limit)
    },

    getConfidenceColor (confidenceValue) {
      return 'rgba('+131+','+201+','+138+','+confidenceValue*confidenceValue+')'
    },

    formatConfidenceValue (confidenceValue) {
      return (parseFloat(confidenceValue)).toFixed(4)
    },

    getTopConfidences (confidences, amount) {
      return confidences.slice(0, amount)
    },

    showIntentLabel (e, phraseIndex, confIndex) {
      const elem = this.$refs['refConf'+phraseIndex+'0'][0]
      const elemCrds = elem.getBoundingClientRect()
      const popup = this.$refs.refIntentLabel

      this.labelToShow = this.getActualPage()[phraseIndex].confidences[confIndex].intents_name
      setTimeout(() => {
        popup.style.top = elemCrds.top - popup.clientHeight - 8 + 'px'
        popup.style.left = elemCrds.left + 'px'
      }, 0)
    },

    hideIntentLabel () {
      this.labelToShow = null
    },

    showConfidences (phraseIndex) {
      this.confidencesToShow = this.phrases[this.page * this.limit + phraseIndex].confidences
    },

    hideConfidences () {
      this.confidencesToShow = null
    },

    intentSelect (intentId, index) {
      for(let i = 0; i<this.intents.length; i++) {
        if(this.intents[i].id == intentId) { 
          this.addPhraseToIntent(this.intents[i], this.page*this.limit+index)
          break
        }
      }
    },

    async delSaved (index) {
      try {
        await axios.delete('/api/plugin/nlp/saved/delete', {
          data: {
            id: this.phrases[this.page*this.limit+index].id
          }
        })
        
        this.phrases.splice(this.page*this.limit+index, 1)
        this.notify('success', 'plugins.nlp.success.savedPhrases.delete')
      } catch (e) {
        this.notify('error', 'plugins.nlp.error.savedPhrases.delete')
        console.error(e)
      }
    },

    // processing
    async addPhraseToIntent (intent, index) {
      try {
        let phrase = await this.buildPhrase(this.phrases[index].phrase, intent.parameters)
        this.replaceParameterReferenceWithIdOrIndex(phrase, intent.parameters)
        let paramsToCreate = []
        let trainingPhraseToCreate = {
          intents_id: intent.id,
          segments: phrase
        }
        for(let i = 0; i<intent.parameters.length; i++) {
          let actParam = intent.parameters[i]
          if(actParam.id === undefined) {
            actParam.intents_id = intent.id
            paramsToCreate.push(actParam)
          }
        }
        let res = await axios.post('/api/plugin/nlp/saved/assign', {
          trainingPhrase: trainingPhraseToCreate,
          parameters: paramsToCreate,
          savedId: this.phrases[index].id
        })
        
        const paramsIds = res.data.paramsIds
        const phraseIds = res.data.phraseIds

        for(let i = 0; i<paramsToCreate.length; i++) {
          paramsToCreate[i].id = paramsIds[i]
        }
        trainingPhraseToCreate.id = phraseIds.id
        for(let i = 0; i<trainingPhraseToCreate.segments.length; i++) {
          trainingPhraseToCreate.segments[i].id = phraseIds.segmentsIds[i]
          if(trainingPhraseToCreate.segments[i].parameter_index !== undefined) {
            trainingPhraseToCreate.segments[i].parameters_id = paramsIds[trainingPhraseToCreate.segments[i].parameter_index]
            delete trainingPhraseToCreate.segments[i].parameter_index
          }
        }
        intent.training_phrases.push(trainingPhraseToCreate)

        this.phrases.splice(index, 1)
        this.notify('success', 'plugins.nlp.success.savedPhrases.assign')
      } catch (e) {
        this.notify('error', 'plugins.nlp.error.savedPhrases.assign')
        console.error(e)
      }
    },

    async buildPhrase (text, parameters) {
      // matched parts of texts will be excluded from segmentation
      let regexed = this.findRegexesParameters(text, this.entities.regexEntities, parameters)
      let textsToSegmentize = regexed.filter(item => { if(!item.ortho) return true })
      let segmentizedTexts = await this.segmentizeAndFindParameters(textsToSegmentize, parameters)
      let phrase = []
      for(let i = 0; i<regexed.length; i++) {
        if(regexed[i].ortho === undefined) {
          let part = segmentizedTexts.shift()
          phrase = phrase.concat(part)
        } else {
          phrase.push(regexed[i])
        }
      }
      return phrase
    },

    findRegexesParameters (text, regexEntities, parameters) {
      let final = [text]
      for(let i = 0; i<regexEntities.length; i++) {
        for(let j = 0; j<regexEntities[i].entities_regexes.length; j++) {
          let actRegex = regexEntities[i].entities_regexes[j]
          let reg = new RegExp(actRegex.exp, 'g')
          let parts = []
          for(let k = 0; k<final.length; k++) {
            if(final[k].ortho === undefined) {
              let foundOrthos = final[k].match(reg) // grabbing matched text
              if(foundOrthos === null) continue
              let splitted = final[k].split(reg)
              let segmentsToConnect = []
              for(let l = 0; l<foundOrthos.length; l++) { // inserting segment connected to regex entity
                let segment = {
                  ortho: foundOrthos[l],
                  lemma: ''
                }
                segmentsToConnect.push(segment) // connecting parameters
                splitted.splice(l+l+1, 0, segment)
              }
              this.addOrConnectParameter(segmentsToConnect, regexEntities[i], parameters)
              splitted = splitted.filter(item => { if(item !== '') return true })
              let begin = final.splice(0, k)
              let end = final.splice(1)
              final = begin.concat(splitted.concat(end))
              k += splitted.length-1
            }
          }
        }
      }
      return final
    },

    findTextParameters (phraseSegments, entities, parameters) {
      // for every text entity
      for(let i = 0; i<entities.textEntities.length; i++) {
        // every entry
        for(let j = 0; j<entities.textEntities[i].entities_entries.length; j++) {
          // values (value + synonyms)
          for(let k = 0; k<entities.textEntities[i].entities_entries[j].entries_values.length; k++) {
            let entitySegments = entities.textEntities[i].entities_entries[j].entries_values[k].values_segments
            for(let l = 0; l<phraseSegments.length-entitySegments.length+1; l++) {
              let subPhrase = []
              for(let n = 0; n<entitySegments.length; n++) {
                subPhrase.push(phraseSegments[l+n])
              }
              if(this.compareSegmentsLemma(subPhrase, entitySegments)) {
                this.addOrConnectParameter(subPhrase, entities.textEntities[i], parameters)
              }
            }
          }
        }
      }
    },

    async segmentizeAndFindParameters (texts, parameters) {
      try {
        let segmentized = await axios.post('/api/plugin/nlp/segmentize', {
          texts: texts
        })
        let segmentizedTexts = segmentized.data.segments
        for(let i = 0; i<segmentizedTexts.length; i++) {
          this.findTextParameters(segmentizedTexts[i], this.entities, parameters)
        }
        return segmentizedTexts
      } catch (e) {
        console.error(e)
      }
    },

    replaceParameterReferenceWithIdOrIndex (segments, parameters) {
      for(let i = 0; i<segments.length; i++) {
        if(!segments[i].parameter) continue;
        // if parameter have id
        if(segments[i].parameter.id) {
          let id = segments[i].parameter.id
          segments[i].parameters_id = id
        } else { 
          // storing via order of not yet saved items in parameters array 
          let counter = 0
          for(let j = 0; j<parameters.length; j++) {
            if(parameters[j] == segments[i].parameter) {
              segments[i].parameter_index = counter
              break;
            }
            if(!parameters[j].id) counter++
          }
        }
        delete segments[i].parameter
      }
    },

    compareSegmentsLemma (subPhrase, entitySegments) {
      for(let i = 0; i<subPhrase.length; i++) {
        if(subPhrase[i].lemma !== entitySegments[i].lemma || subPhrase[i].parameter) {
          return false
        }
      }
      return true
    },

    addOrConnectParameter (segments, entity, parameters) {
      // is connection already in parameters table
      let param = null
      for(let i = 0; i<parameters.length; i++) {
        if(entity.id === parameters[i].entities_id) {
          param = parameters[i]
          break;
        }
      }
      // if not
      if(!param) {
        param = {
          name: entity.name,
          entities_id: entity.id,
          active: true
        }
        parameters.push(param)
      }
      for(let i = 0; i<segments.length; i++) {
        segments[i].parameter = param
      }
    },
    //

    async fetchSavedPhrases () {
      try {
        let res = await axios.get('/api/plugin/nlp/saved/list')
        this.formatFetched(res.data.savedPhrases)
      } catch (e) {
        console.error(e)
      }
    },

    formatFetched (data) {
      let formatted = []
      let i = 0
      while(i<data.length) {
        let saved_phrase = {
          id: data[i].saved_phrases_id,
          phrase: data[i].phrase,
          confidences: []
        }
        while(i<data.length && data[i].saved_phrases_id === saved_phrase.id) {
          let confidence = {
            intents_name: data[i].intents_name,
            confidence: data[i].confidence
          }
          saved_phrase.confidences.push(confidence)
          i++
        }
        saved_phrase.confidences = saved_phrase.confidences.sort((a, b) => {
          const n1 = +a.confidence
          const n2 = +b.confidence

          if(n1 < n2) return 1
          else if(n1 > n2) return -1
          else return 0
        })
        formatted.push(saved_phrase)
      }

      this.phrases = formatted
    }
  }
}
</script>

<style lang="scss">
.saved-phrases {
  width: 100%;
  height: 100%;

  &__conf-popup {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 20000;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.75);

    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__conf-list {
    background: white;
    border-radius: 8px;
    padding: 6px 12px 12px 12px;

    width: 360px;
    //max-height: 100px;
  }

  &__conf-list-header {
    width: 360px;
    display: grid;
    grid-template-columns: 1fr min-content;
    border-bottom: solid 1px $inactiveGrey;
    padding-bottom: 4px;
    align-items: center;
  }

  &__conf-header-title {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;

    display: flex;
    justify-content: center;
    font-weight: bold;
  }

  &__conf-header-icon {
    grid-column-start: 2;
    grid-row-start: 1;
    cursor: pointer;
    padding: 2px;
  }

  &__conf-list-content {
    max-height: 320px;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
  }

  &__conf-list-elem:nth-child(2n+1) {
    background: #EEF5F2;
  }

  &__conf-list-elem {
    display: flex;
    justify-content: space-between;
    padding: 6px 4px;
  }

  &__conf-list-intent {
    width: 70%;
  }

  &__conf-list-conf {
    padding-left: 12px;
    font-weight: bold;
  }

  /////////////////////////////////////////////////////

  &__top-label-popup {
    position: absolute;
    background: white;
    padding: 4px 6px;
    border-radius: 6px;
    border: solid 1px rgb(182, 182, 182);
  }

  /////////////////////////////////////////////////////

  &__table {
    padding: 16px;
    width: calc(100% - 32px);
    height: calc(100% - 32px);
    display: grid;

    grid-template-columns: minmax(100px, 1fr) 1.8fr minmax(90px, 120px) minmax(90px, 120px) minmax(60px, 120px);
    grid-template-rows: 30px 1fr 50px;
    grid-row-gap: 8px;
  }

  &__header {
    border-bottom: 1px solid black;
    font-weight: bold;

    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding: 6px 0px;
  }

  &__text-header {
    justify-content: left;
  }

  &__content {
    grid-column-start: 1;
    grid-column-end: -1;

    display: grid;
    grid-auto-flow: column;
    align-items: center;
    grid-template-columns: minmax(100px, 1fr) 1.8fr minmax(90px, 120px) minmax(90px, 120px) minmax(60px, 120px);
    //grid-template-rows: repeat(auto-fill, fit-content(300px));
    grid-auto-rows: minmax(min-content, max-content);
    grid-row-gap: 18px;
    overflow: scroll;
  }

  &__no-data-text {
    color: $inactiveGrey;
    font-weight: bold;
  }

  &__text-elem {
    grid-column-start: 1;
    display: flex;
    align-items: center;
    overflow-y: scroll;
    max-height: 140px;
    padding-right: 2px;
  }

  &__top-conf-elem {
    grid-column-start: 2;
    align-self: center;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    padding-left: 6px;
  }

  &__top-conf-item {
    padding: 8px;
    border-radius: 4px;
  }

  &__info {
    grid-column-start: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 6px;
  }

  &__info-icon {
    cursor: pointer;
    padding: 4px;
  }

  &__assign {
    grid-column-start: 4;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 6px;
  }

  &__del {
    grid-column-start: 5;

    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 6px;
  }

  &__del-icon {
    padding: 4px;
    cursor: pointer;
  }

  &__footer {
    grid-column-start: 1;
    grid-column-end: -1;

    border-top: 1px solid rgb(187, 187, 187);
    //background: #F7FAF9;

    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  &__navi-actual {
    display: flex;
    align-items: center;
    font-weight: bold;
    user-select: none;
  }

  &__navi-action {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__navi-buttons {
    display: flex;
    align-items: center;
  }

  &__navi-buttons-icon {
    padding: 6px;
    cursor: pointer;

    &--inactive {
      user-select: none;
      color: $inactiveGrey;
    }
  }

  &__navi-text {
    padding: 6px;
    font-weight: bold;
    user-select: none;
  }
}
</style>
